export const eventsData = {
  upcoming: [
    {
      date: 'Friday, March 13, 2026',
      title: 'Sneaky Link Friday',
      description: 'Experience the ultimate Friday night with top DJs, premium bottle service, and an exclusive VIP experience. Dress code: Upscale elegant.',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/52d59385496b333797e917eef1b3302a.jpeg'
    },
    {
      date: 'Saturday, March 14, 2026',
      title: 'Sin City(Stripper Night)',
      description: 'Join Benin City\'s elite for an unforgettable Saturday night. Live performances, celebrity appearances, and world-class entertainment.',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/97f962057fd1fee15b63f5c542a2f69a.jpeg'
    },
    {
      date: 'Sunday, March 15, 2026',
      title: 'Unruly',
      description: 'An extravagant night of luxury and opulence. Gold-themed decor, premium entertainment, and exclusive bottle service. Dress in gold.',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/55567bf60e7417892489659126d451ec.jpeg'
    }
  ],
  recent: [
    {
      date: 'Sunday, June 22, 2025',
      title: 'Unruly',
      description: 'Unruly Night at King Square Club was exactly what the name promised — wild, energetic, and completely unforgettable. The club was packed with party lovers ready to let loose and experience a night with no limits.\nFrom the moment the music started, the atmosphere was intense. The DJs delivered nonstop hip-hop and club anthems that kept the crowd moving, while the lights, dancers, and premium bottle service added to the electrifying vibe inside the club',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/dcfeda6e0dbfdfa5c3b1c86720ad9849.jpeg'
    },
    {
      date: 'Friday, Mar 06, 2026',
      title: 'Party with Peller',
      description: 'Party With Peller was an unforgettable night filled with excitement, laughter, and nonstop entertainment at King Square Club. The club came alive as fans and party lovers gathered to experience the vibe and energy that Peller brought to the building.',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/3f8020b674dddda606a995e2d2417c91.jpeg'
    },
    {
      date: 'Saturday, Feb 28, 2026',
      title: 'Grand Opening Ceremony',
      description: 'The grand opening of King Square Club was nothing short of legendary. The night welcomed a wave of stylish guests, party lovers, and VIPs who came ready to experience something new in Benin\'s nightlife scene. From the moment the doors opened, the atmosphere was electric — luxury lights, premium sounds, and an energy that filled every corner of the club.',
      image: 'https://static.readdy.ai/image/fef20157eea1fb1d08dc062c0ae5461e/ccb33bdead357ace8f49198dd5d5f731.jpeg'
    }
  ]
};
